import { createContext, useContext } from "react";
import { useDisclosure } from "@chakra-ui/hooks";
import Modal from "components/Modals/refer/ClaimReward";

const ClaimRewardContext = createContext(null);

function ClaimRewardProvider({ children }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <ClaimRewardContext.Provider value={{ onOpen }}>
      {children}

      <Modal isOpen={isOpen} onClose={onClose} />
    </ClaimRewardContext.Provider>
  );
}

function useClaimReward() {
  const context = useContext(ClaimRewardContext);
  if (!context) throw new Error("Claim reward provider is not available");
  return context;
}

export { ClaimRewardContext, ClaimRewardProvider, useClaimReward };
